module.exports = __webpack_public_path__ + "static/media/cross-browser-problems-and-solution.eb18bbf7.jpg";